<template>
  <div class="container text-center container-vende-tu-auto">

    <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center">
      <img class="step-desktop" src="../assets/imgs/desktop/vende_tu_auto_paso3_web.png" alt="AUTOCOM" />
      <img class="step-tablet" src="../assets/imgs/tablet/vende_tu_auto_paso3_tablet.png" alt="AUTOCOM" />
      <img class="step-mobile" src="../assets/imgs/mobile/vende_tu_auto_paso3_mobile.png" alt="AUTOCOM" />
    </div>

    <div class="container container-info">
      <div class="container-vende-view">
        <div class="content-va">

          <!-- Oferta -->
          <div v-if="this.oferta === true" class="row text-center info-auto-oferta">

            <div class="oferta-tituloinfo">
              <h4 class="titulo-oferta"> {{nombre}}, esta es tu oferta AUTOCOM</h4>
            </div>
            <div class="marcaModeloAño oferta-infoauto">{{ año }} <span class="black">{{ marca }} {{ modelo }}</span>
            </div>
            <div class="versionColorKm mb-2 text-uppercase versionColorKm-aux">{{ version }} <span class="pipe">|</span>
              {{ color }} <span class="pipe">|</span> {{ formatPrice(kilometraje) }} KM</div>

            <div class="nofolio mb-3">
              <h4 class="titulo-nofolio">NO. DE OFERTA: {{ folio }}</h4>

            </div>

            <div class="col-1">&nbsp;</div>

            <div class="oferta-wrpr col-10 justify-content-center">
              <h4 class="mejor-oferta">EL RANGO DE TU <br> MEJOR OFERTA <span>GARANTIZADA</span> ES</h4>
              <b-col>
                <h5 class="oferta"> <span class="ofertaLight">DE</span> ${{ formatPrice(formatValue(this.ofertaMin)) }}.00* <span
                    class="ofertaLight">A</span> ${{ formatPrice(formatValue(this.ofertaMax)) }}.00*</h5>
              </b-col>
            </div>
            <div class="col-1">&nbsp;</div>
            <br />
            <br />

            <div class="margin-oferta1 col-md-12 text-center mt-3">
              <p class="texto-oferta">
                Esta oferta es válida hasta el <strong>{{ this.validezVA }}</strong><br />*El monto final de la oferta
                depende de la inspección del vehículo
              </p>

              <p class="texto-oferta mt-1">
                Conoce los documentos que necesitas para vender tu auto, <span class="enlace"
                  @click="documentacion()">haz clic aquí</span>
              </p>
              <p class="textoagendar">Obtén una inspección precisa de tu vehículo en nuestras agencias o en la comodidad
                de tu hogar con nuestro servicio de inspección a domicilio.</p>
            </div>
            <br />

            <div class="col-12 desktop" style="">
              <div class="row" style="margin-top: -25px;">
                <div class="col-6 right-2">
                  <button type="button" class="btn-agencia" @click.prevent="agencia()"><img class="btn-img-dom"
                      src="../assets/imgs/btn_agencia_on.png" /></button>
                </div>
                <div class="col-6 left-2">
                  <button type="button" class="btn-domicilio" @click.prevent="domicilio()"><img class="btn-img-dom"
                      src="../assets/imgs/btn_domicilio_on.png" /></button>
                </div>
              </div>
              <div>
                <button type="button" style="" @click.prevent="cancelar()" class="mt-5 -btn-cancel">
                  RECHAZAR OFERTA
                </button>
              </div>
            </div>

          </div>

          <!-- No Oferta -->
          <div v-if="this.noOferta === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">OFERTA NO VALIDA</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  La oferta ingesada ya no es vigente <br> recuerda que las ofertas tienen una validez de 8 días
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

          <!-- No Encontrado -->
          <div v-if="this.noEncontrado === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">FOLIO NO ENCONTRADO</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  El folio ingesado no se encuentra <br> en nuestro sistema, intenta con un folio valido
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

          <!-- No en Seguimiento -->
          <div v-if="this.enSeguimiento === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">OFERTA EN SEGUIMIENTO</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  Un asesor ya ha tomado la Oferta para darle seguimiento, <br> en breve se contactará contigo.
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

        </div>
      </div>
    </div>

    <b-modal v-model="modalnoValido" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">
          <div class="modal-title mt-5">OFERTA NO VALIDA</div>

          <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

          <div class="lamentamos mt-3">
            La oferta ingesada ya no es vigente <br> recuerda que las ofertas tienen una validez de 8 días
          </div>
        </div>

        <div class="text-center mt-4">
          <div class="controls">
            <button class="" @click.prevent="cerrarModal()">
              CERRAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

    <b-modal v-model="modalCancelacion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">
        <div class="col-sm-12 text-center">

          <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />
          <div class="modal-title mt-0">Rechazo de la oferta</div>
          <div class="lament">
            Selecciona el motivo del<br/>rechazo de la oferta
          </div>

          <!--div class="mt-4">
            <h5 class="label-folio-3">Cuasa de rechazo</h5>
            <select class="form-select select margin-doml" @change="getMotivos()" required v-model="rechazo"
              style="text-overflow: ellipsis;">
              <option selected disabled value=''>
                Elige una opción
              </option>
              <option v-for="item in rechazos" :key="item.id" :value="[item.id]">
                {{ item.descripcion }}
              </option>
            </select>
          </div-->

          <div class="mt-4">
            <h5 class="label-folio-4">Motivo de rechazo</h5>
            <select class="form-select select margin-doml" required v-model="motivo" style="text-overflow: ellipsis;">
              <option selected disabled value=''>
                Elige una opción
              </option>
              <option v-for="item in motivos" :key="item.id_motivo" :value="[item.id_motivo]">
                {{ item.motivo }}
              </option>
            </select>
          </div>

        </div>
        <div class="controls row">

          <div class="col-md-6 col-sm-12  order-md-2 right">
            <button v-if="this.motivo === ''" disabled class="btn-oferta-rojo -btn-continuar continue">
              RECHAZAR
            </button>
            <button v-if="this.motivo !== ''" class="btn-oferta-rojo -btn-continuar continue"
              @click.prevent="cancelarSolicitud()">
              RECHAZAR
            </button>
          </div>
          <div class="col-md-6 col-sm-12  order-md-1 left">
            <button class="btn-oferta-negro -btn-continuar continue" @click.prevent="cerrarCancelar()">
              CERRAR
            </button>
          </div>

        </div>
      </b-row>
    </b-modal>

    <b-modal v-model="modalErrorConexion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">
          <div class="modal-title mt-5">ERROR EN NUESTRO SISTEMA</div>

          <img class="ico-inspeccion" src="../assets/imgs/error_varios_icon.svg" alt="AUTOCOM" />

          <div class="lamentamos mt-3">
            Nuestro servicio está presentando errores, por el<br> momento no es posible realizar la operación, inténtalo
            <br> más tarde. <br> <span class="msnError">{{this.mensajeError}}</span>
          </div>
        </div>

        <div class="text-center mt-4">
          <div class="controls">
            <button class="" @click.prevent="cerrarModal()">
              CERRAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: "Oferta",

  components: {},

  data() {
    return {

      // server: 'https://srv-autocheck.autocomseminuevos.com/api',

      /*serverAnalizador: 'https://api-analizador.autocom.mx/api',
      serverAutoCheck: 'https://api-autocheck.autocom.mx/api',
      creatioService: 'https://creatioservice.autocom.mx/api',
      serverComunicaciones: 'https://comunicaciones.autocom.mx/api',
      serverNotificaciones: 'https://srv-notificaciones.autocom.mx/api',*/

      // serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      //server: 'https://dev-srv-valoraciones.autocom.mx/api',


       serverAnalizador: process.env.VUE_APP_SERVER_ANALIZADOR,
       serverAutoCheck: process.env.VUE_APP_SERVER_AUTOCHECK,
       creatioService: process.env.VUE_APP_CREATIO_SERVICE,
       serverComunicaciones: process.env.VUE_APP_SERVER_COMUNICACIONES,
       serverNotificaciones: process.env.VUE_APP_SERVER_NOTIFICACIONES,


      marca: "",
      modelo: "",
      año: "",
      ofertaVa: "",
      ofertaMin: "",
      ofertaMax: "",
      folio: sessionStorage.getItem("idvaloration"),
      valoracion:sessionStorage.getItem("idvaloration"),
      version: "",
      color: "",
      kilometraje: "",
      validezVA: "",
      folioMail: '',
      modalTipoV: false,
      modalCancelacion: false,
      modalnoValido: false,
      modalErrorConexion: false,
      mensajeError: "",
      nombre: sessionStorage.getItem("nombre"),
      apellidos: sessionStorage.getItem("apellidos"),
      seguimiento: "",
      oferta: false,
      noOferta: false,
      noEncontrado: false,
      enSeguimiento: false,

      rechazos: [],
      rechazo: '',
      motivos: [],
      motivo: ''
    };
  },

  methods: {

    tokenComunicaciones() {
      let user = { usuario: "Comunicaciones", password: "C0mun1c4c10n35" };
      axios.post(this.serverComunicaciones + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenComunicacion", response.data.token);
        }).catch((error) => {
          this.mensajeError1 = 'ECOTK';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones ...', error.message)
        });
    },

    snifferError(error, servicio) {

      let data = {
        error: error,
        servicio: servicio,
      }


      axios.post(this.serverComunicaciones + "/snifferVa", data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Alerta enviada');
        })
        .catch((error) => {
          console.log('Error de alerta --->', error);
        });

    },

    cargarToken() {
      let user = { usuario: "autocom_seminuevos", password: "invarart2022Semi" };
      axios
        .post(this.serverAutoCheck + "/auth", user)
        .then((response) => {
          //console.log('token autocheck -->', response.data.token);
          sessionStorage.setItem("tokenIntelimotor", response.data.token);
          this.validaFolio();
        }).catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EACT';
          this.snifferError(error.message,'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },

    agendar() {
      this.modalTipoV = true;
    },

    cancelar() {
      this.modalCancelacion = true;
    },

    cerrar() {
      this.modalTipoV = false;
    },

    cerrarCancelar() {
      this.modalCancelacion = false;
    },

    async cerrarModal() {
    this.noOferta = true;
    this.modalnoValido = false;
    this.modalErrorConexion = false;

    },

    async nuevaOferta() {
      clearInterval(this.intervalos);
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 150);
    },

    async agencia() {
      this.modalTipoV = false;
      clearInterval(this.intervalos);
        setTimeout(() => {
          this.$router.push({ path: "/Evaluacion" });
        }, 150);
      sessionStorage.setItem("tipoInspeccion", "agencia");
    },

    async domicilio() {
      this.modalTipoV = false;
      clearInterval(this.intervalos);
        setTimeout(() => {
          this.$router.push({ path: "/Evaluacion" });
        }, 150);
      sessionStorage.setItem("tipoInspeccion", "domicilio");
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatValue(value) {
      let val = Math.round(value / 100) * 100;
      return val
    },

    validaFolio() {
      //console.log('Folio --->', this.folioMail);
    this.folioMail = this.$route.query.vafolio;

      if (this.folioMail !== undefined ) {

        sessionStorage.setItem("folioMail", this.folioMail);
        //console.log('Folio --->',this.folioMail);
        this.validaAgendamiento();

      } else {
        console.log('Oferta True');

        this.vigenciaOferta();
      }
    },

    validaAgendamiento() {

      let body = { folio: this.$route.query.vafolio,
          telefono: this.telefono
          };

    axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
        body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {

        //console.log('response -->',response.data);

        if (response.data.data.status === 204) {

          this.noOferta = false;
          this.oferta = false;
          this.noEncontrado = true;
          this.enSeguimiento = false;
          this.modalnoValido = false;

        } else if (response.data.data[0].para_reagendamiento === "No") {

          this.noOferta = false;
          this.oferta = false;
          this.noEncontrado = false;
          this.enSeguimiento = true;
          this.modalnoValido = false;

        } else {

          this.validaVigencia();

        }

      })
      .catch((error) => {
        this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
        this.errorvaloracion = true;
        console.log(error.response.status);

        if (error.response.status === 400) {
          this.noOferta = false;
          this.oferta = false;
          this.noEncontrado = true;
          this.enSeguimiento = false;
          this.modalnoValido = false;
        } else {
          this.mensajeError = 'EVAVF';
          this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        }
      });

    },

    vigenciaOferta() {

      console.log('Valida agendamiento');

      let body = { folio: sessionStorage.getItem("idvaloration"),
            telefono: this.telefono
            };

      axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          //console.log(response.data.data[0]);

          const date = new Date();
          // const output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
            const dia = new Date(output).getTime();
            const diac = Math.round(dia/(1000*60*60*24));

          this.diaActual = output;
          this.diaVigencia = response.data.data[0].vigencia_oferta.substring(0,2);
          this.mesVigencia = response.data.data[0].vigencia_oferta.substring(3,5);
          this.anioVigencia = response.data.data[0].vigencia_oferta.substring(6,10);
          this.fechaVigencia = this.anioVigencia+'-'+this.mesVigencia+'-'+this.diaVigencia;
          const dia2 = new Date(this.fechaVigencia).getTime();
          const diac2 = Math.round(dia2/(1000*60*60*24));

          //console.log('Días -->',diac+' - '+diac2);

          if (diac > diac2) {

            this.noOferta = true;
            this.oferta = false;
            this.noEncontrado = false;
            this.enSeguimiento = false;
            this.modalnoValido = true;

            } else {

              this.marca = sessionStorage.getItem("marca");
              this.modelo = sessionStorage.getItem("modelo");
              this.año = sessionStorage.getItem("anio");
              this.ofertaVa = sessionStorage.getItem("oferta");
              this.folio = sessionStorage.getItem("folio");
              this.version = sessionStorage.getItem("version");
              this.color = sessionStorage.getItem("color");
              this.kilometraje = sessionStorage.getItem("kilometraje");
              this.validezVA = sessionStorage.getItem("fecha_validez");

              this.ofertaMin = (this.ofertaVa - (this.ofertaVa * .10));
              //this.ofertaMax = (Number(this.ofertaVa) + (this.ofertaVa * .02));
              this.ofertaMax = this.ofertaVa;              
              sessionStorage.setItem("ofertaMin", this.ofertaMin);
              sessionStorage.setItem("ofertaMax", this.ofertaMax);

              console.log('Oferta -->', this.ofertaVa);
              console.log('Oferta Min -->', this.ofertaMin);
              console.log('Oferta Max -->', this.ofertaMax);

              this.noOferta = false;
              this.oferta = true;
              this.noEncontrado = false;
              this.enSeguimiento = false;
              this.modalnoValido = false;              

            }
        })
        .catch((error) => {
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError = 'EVAVVF';
          this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error);
        });

      },

    validaVigencia() {

    let body = { folio: this.$route.query.vafolio,
          telefono: this.telefono
          };

    axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
        body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {

        const date = new Date();
        // const output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
        const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
          const dia = new Date(output).getTime();
          const diac = Math.round(dia/(1000*60*60*24));

        this.diaActual = output;
        this.diaVigencia = response.data.data[0].vigencia_oferta.substring(0,2);
        this.mesVigencia = response.data.data[0].vigencia_oferta.substring(3,5);
        this.anioVigencia = response.data.data[0].vigencia_oferta.substring(6,10);
        this.fechaVigencia = this.anioVigencia+'-'+this.mesVigencia+'-'+this.diaVigencia;
        const dia2 = new Date(this.fechaVigencia).getTime();
        const diac2 = Math.round(dia2/(1000*60*60*24));

        //console.log('Días -->',diac+' - '+diac2);

        if (diac > diac2) {

          this.noOferta = true;
          this.oferta = false;
          this.noEncontrado = false;
          this.enSeguimiento = false;
          this.modalnoValido = true;

          } else {

          if ( this.seguimiento === 'creatio') {
            console.log('consulta creatio');
            //this.consultaCreatio();
            this.validaInfoFolio()
          } else {
              console.log('Cliente atendido por un asesor');
            this.validaInfoFolio();
          }

          }
      })
      .catch((error) => {
        // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
        this.mensajeError = 'EVAVVF';
        this.modalErrorConexion = true;
        this.snifferError(error.message, 'valoraciones');
        console.log('Existe un error en valoraciones ...', error.message);
      });

    },

    tokenCreatio(){
        let user = {usuario: "CreatioService", password: "Cr34t1053rv1c3"};
        axios.post(this.creatioService + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          this.getRechazo();
          sessionStorage.setItem("tokenCreatio", response.data.token);
        }).catch((error) => {
          // this.mensajeError = 'ECTKN';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
        });
    },

    /*consultaCreatio(){

    console.log('Consulta Creatio');

    this.idAutocheck = this.$route.query.vafolio;

    axios.get(this.creatioService + '/loadIdCreatio/'+this.idAutocheck,  
      {
        headers: {
          Authorization:
            "Bearer " + sessionStorage.getItem("tokenCreatio"),
          "Content-Type": "application/json",
        },
      })
    .then(response =>{
      //console.log('Respuesta -->',response.data[0].idcreatio);
      sessionStorage.setItem("IdCreatio", response.data[0].idcreatio);
      sessionStorage.setItem("nombre", response.data[0].nombre);
      sessionStorage.setItem("apellidos", response.data[0].apellidos);
      this.nombre = sessionStorage.getItem("nombre");
      this.apellidos = sessionStorage.getItem("apellidos");
      this.validaInfoFolio();
    }).catch(error=>{
      // this.mensajeError = 'ECCID';
      // this.modalErrorConexion = true;
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
    });

    },*/

    validaInfoFolio() {

      let body = { folio: this.$route.query.vafolio,
            telefono: this.telefono
            };

      axios.post(
          this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          this.agendamiento = response.data.data[0].tiene_agendamiento;
          //console.log('Respuesta -->', response.data.data[0].vigencia_oferta );

          if (this.agendamiento === 0) {

            sessionStorage.setItem("idcliente", response.data.data[0].id_cliente);
            sessionStorage.setItem("email", response.data.data[0].email);
            sessionStorage.setItem("telefono", response.data.data[0].telefono);
            sessionStorage.setItem("folio", response.data.data[0].folioVA);
            sessionStorage.setItem("idvaloration", response.data.data[0].folio);
            sessionStorage.setItem("oferta", response.data.data[0].oferta);
            sessionStorage.setItem("offer_day", response.data.data[0].oferta_hoy);
            sessionStorage.setItem("offer_consignment", response.data.data[0].oferta_consignacion);
            sessionStorage.setItem("fecha_validez", response.data.data[0].vigencia_oferta.substring(0,10));
            sessionStorage.setItem("marca", response.data.data[0].marca);
            sessionStorage.setItem("modelo", response.data.data[0].modelo);
            sessionStorage.setItem("anio", response.data.data[0].year);
            sessionStorage.setItem("version", response.data.data[0].trim);
            sessionStorage.setItem("color", response.data.data[0].ext_color);
            sessionStorage.setItem("kilometraje", response.data.data[0].kilometers);
            this.marca = sessionStorage.getItem("marca");
            this.modelo = sessionStorage.getItem("modelo");
            this.año = sessionStorage.getItem("anio");
            this.ofertaVa = sessionStorage.getItem("oferta");
            this.folio = sessionStorage.getItem("folio");
            this.version = sessionStorage.getItem("version");
            this.color = sessionStorage.getItem("color");
            this.kilometraje = sessionStorage.getItem("kilometraje");
            this.validezVA = sessionStorage.getItem("fecha_validez");

            this.ofertaMin = (this.ofertaVa - (this.ofertaVa * .10));
            //this.ofertaMax = (Number(this.ofertaVa) + (this.ofertaVa * .02));
            this.ofertaMax = this.ofertaVa;
            sessionStorage.setItem("ofertaMin", this.ofertaMin);
            sessionStorage.setItem("ofertaMax", this.ofertaMax);

            console.log('Oferta -->', this.ofertaVa);
            console.log('Oferta Min -->', this.ofertaMin);
            console.log('Oferta Max -->', this.ofertaMax);

            if (this.seguimiento !== 'creatio') {
              sessionStorage.setItem("nombre", response.data.data[0].cliente);
              this.nombre = sessionStorage.getItem("nombre")
            } else {
              console.log('Nombre por creatio')
            }
            
            this.noOferta = false;
            this.noEncontrado = false;
            this.enSeguimiento = false;
            this.modalnoValido = false;
            this.oferta = true;

          } else {

            this.noOferta = false;
            this.oferta = true;
            this.noEncontrado = false;
            this.enSeguimiento = false;
            this.modalnoValido = false;
            
            setTimeout(() => {
              this.$router.push({ path: "/Reagendamiento?vafolio="+response.data.data[0].folio });
            }, 150);

          }
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError = 'EVAVF2';
          this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones 1 ...', error);
        });

    },

    opendWindow(){
      clearInterval(this.intervalos);
      window.location.replace('/');
      //console.log('1');
    },

    tiempoActivo(){
      this.intervalos = setInterval(() => {
        this.opendWindow();
      },3600000);
    },

    documentacion() {
      sessionStorage.setItem("prev", "oferta");
      setTimeout(() => {
        // window.open('/Documentos');
        this.$router.push({ path: "/Documentos" });
      }, 150);
    },

    /** rechazos */
    getRechazo() {
      axios
        .get(this.serverAutoCheck + "/causas_rechazo/listado", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        })
        .then(({ data }) => {

          this.rechazos = data.data;
          //console.log('Respuesta --->',this.rechazos);
        })
        .catch((error) => {
          this.snifferError(error.message, 'AutoCheck');
          console.log('Existe un error en autocheck ...', error.message);
        });

    },
    getMotivos() {

      //console.log(this.rechazo[0]);
      axios
        .get(this.serverAutoCheck + "/motivos_rechazo/search_ByCausa?rid_causa=2", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        })
        .then(({ data }) => {

          this.motivos = data.data;
          //console.log('Respuesta --->', this.motivos);
        })
        .catch((error) => {
          this.snifferError(error.message, 'AutoCheck');
          console.log('Existe un error en autocheck ...', error.message);
        });
    },

    async cancelarSolicitud() {
      this.modalCancelacion = false;
      let body = {

        rid_valuacion: sessionStorage.getItem("idvaloration"),
        //dev
        rid_usuario: 170,
        rid_motivo: this.motivo[0],
        comentarios: 'Rechazo VA'
      };

      //console.log('Body -->',body);

      axios.post(this.serverAutoCheck + "/rechazo_valuacion/create", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          this.enviaRechazo();
          //console.log(response);
          setTimeout(() => {
            this.$router.replace({ path: "/" });
          }, 150);
        })
        .catch((error) => {
          // this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError1 = 'EVACV';
          this.modalCancelacion = false;
          this.snifferError(error.message, 'Rechazo');
          console.log('Error en el servicio de valoraciones ...', error.message);
        });
    },

    enviaRechazo() {

      this.ofertamail = this.formatPrice(sessionStorage.getItem("oferta"));
      this.foliomail = sessionStorage.getItem("idvaloration");
      this.idvaloration = sessionStorage.getItem("idvaloration");

      let mail = {
        user: "vendetuauto@autocom.mx",
        aplication: "Vende tu Auto",
        subject: "AUTOCOM OFERTA RECHAZADA",
        EmailsTo: [{ email: this.emailM }],
        EmailsToCc: [{ emailCc: "noreply@autocom.mx" },
        { emailCc: "" }],
        body: `
           <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
            <html>
            <head>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <!-- utf-8 works for most cases -->
            <meta name="viewport" content="width=device-width">
            <!-- Forcing initial-scale shouldn't be necessary -->
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <!-- Use the latest (edge) version of IE rendering engine -->
            <title>Oferta VTA generico</title>
              <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
            <!-- The title tag shows in email notifications, like Android 4.4. -->

            <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
            <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

            <!-- CSS Reset -->
            <style type="text/css">
            /* What it does: Remove spaces around the email design added by some email clients. */
                  /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              height: 100% !important;
              width: 100% !important;
            }
            /* What it does: Stops email clients resizing small text. */
            * {
              -ms-text-size-adjust: 100%;
              -webkit-text-size-adjust: 100%;
            }
            /* What it does: Forces Outlook.com to display emails full width. */
            .ExternalClass {
              width: 100%;
            }
            /* What is does: Centers email on Android 4.4 */
            div[style*="margin: 16px 0"] {
              margin: 0 !important;
            }
            /* What it does: Stops Outlook from adding extra spacing to tables. */
            table, td {
              mso-table-lspace: 0pt !important;
              mso-table-rspace: 0pt !important;
            }
            /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
            table {
              border-spacing: 0 !important;
              border-collapse: collapse !important;
              table-layout: fixed !important;
              margin: 0 auto !important;
              margin-block-end: 5px;
              margin-block-start: 5px;
            }
            table table table {
              table-layout: auto;
            }
            /* What it does: Uses a better rendering method when resizing images in IE. */
            img {
              -ms-interpolation-mode: bicubic;
            }
            /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
            .yshortcuts a {
              border-bottom: none !important;
            }
            /* What it does: Another work-around for iOS meddling in triggered links. */
            a {
                    color: #AF0F2B;
                    text-decoration: underline;
                    font-weight: 700;
                  }

            .cabeza2{
              font-family: Arial,helvetica,sans-serif;
            font-style: italic;
            font-weight: 800;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .unidad{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 0px;
            text-align: center;
            color: #000000;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .anio{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .folio{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .mejor{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top: 25px;
            padding-bottom: 2px;
            }
            .oferta{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 34px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #AF0F2B;
            }
            .div_naranja{
              background-color: #E63E19;

            }
            .validez{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            .inspeccion{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 22px;
            line-height: 150.1%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            </style>

            <!-- Progressive Enhancements -->
            <style type="text/css">
            /* What it does: Hover styles for buttons */
            .button-td, .button-a {
              transition: all 100ms ease-in;
            }
            .button-td:hover, .button-a:hover {
              background: #A50932 !important;
              border-color: #A50932 !important;
            }

            /* Media Queries */
            @media screen and (max-width: 480px) {
            /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
            .fluid, .fluid-centered {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* And center justify these ones. */
            .fluid-centered {
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* What it does: Forces table cells into full-width rows. */
            .stack-column, .stack-column-center {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              direction: ltr !important;
            }
            /* And center justify these ones. */
            .stack-column-center {
              text-align: center !important;
            }
            /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
            .center-on-narrow {
              text-align: center !important;
              display: block !important;
              margin-left: auto !important;
              margin-right: auto !important;
              float: none !important;
            }
            table.center-on-narrow {
              display: inline-block !important;
            }
            }
            </style>
            </head>
            <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
            <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
              <tr>
                <td><center style="width: 100%;">

                    <!-- Visually Hidden Preheader Text : BEGIN -->
                    <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Esta es tu oferta AUTOCOM </div>
                    <!-- Visually Hidden Preheader Text : END -->

                    <div style="max-width: 600px;">
                      <!--[if (gte mso 9)|(IE)]>
                        <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                        <tr>
                        <td>
                        <![endif]-->

                      <!-- Email Header : BEGIN -->
                      <div style="width:100%">

                        <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head3.jpg" alt="" bgcolor="#ffffff">

                      </div>

                      <!-- Email Header : END -->

                      <!-- Email Body : BEGIN -->
                      <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">

                      <!-- 1 Column Text : BEGIN -->
                        <tr>
                          <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                              <tr>
                                <td style="padding: 30px;padding-bottom:0px; text-align: center;">

                                <h1>
                                  <span style="font-family:Arial,Helvetica,sans-serif; font-weight: 800; font-size: 34px; line-height: 150%; text-align: center; color: #AF0F2B; padding-bottom: 5px;">HOLA ${this.nombre.toUpperCase()}</span>
                                </h1>
                                <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                                  <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Haz decidido no aceptar la oferta que tenemos para ti</span>
                                  <br>
                                  <span class="unidad"style="font-family:Arial,Helvetica,sans-serif;font-size: 28px;color:#000000;line-height:150%"><b><span class="anio"style="color: #696969">${this.año} </span>${this.marca} ${this.modelo} </b></span>
                                  <br>
                                  <span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. DE OFERTA: ${this.foliomail}</span>
                                </p>
                                  <p class="mejor" style="margin-block-end: 0px;font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969">EL RANGO DE TU<BR>MEJOR OFERTA <b><span style="color:#000000">GARANTIZADA</span></b> ES<br>
                                    <span class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 5px;margin-block-end:5px;font-size: 34px;color:#AF0F2B;text-align: center">DE <B>$ ${this.formatPrice(this.formatValue(this.ofertaMin))}*</B><br>A <B>$ ${this.formatPrice(this.formatValue(this.ofertaMax))}*</B></span>
                                    <span class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969"><br>
                                    Esta oferta es válida hasta el <b>${this.validezVA}</b><br>
                                    *El monto final de la oferta depende de la inspección del vehículo
                                  </span>
                                </p>
                                  </td>
                                  </tr>
                              <tr>
                                <td>
                                  <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 22px;color: #696969" class="inspeccion"><b>La oferta estará disponible para ti, si decides retomarla <a href="https://${this.iframe}/Oferta?vafolio=${this.idvaloration}&seguimiento=creatio" style="color:#AF0F2B">haz clic aquí</a></b>
                                  </p>
                                  <hr size="1px" color="#D9D9D9" width="90%">
                                        <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                          Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                        </p>
                                </td>
                              </tr>
                            </table></td>
                        </tr>
                      <!--[if (gte mso 9)|(IE)]>
                        </td>
                        </tr>
                        </table>
                        <![endif]--> 
                    </div>
                  </center></td>
              </tr>
            </table>
            </body>
            </html>
           `};

      axios.post(this.serverNotificaciones + "/emailSend", mail, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        console.log('Mail rechazo--->', response.status);
      }).catch(error => {
        console.log('Algo salio mal mail --->', error.message);
        this.snifferError(error.message, 'Notificaciones');
      });
    },

  },

  created() {

    this.folio=sessionStorage.getItem("idvaloration");
    console.log("FOLIO "+sessionStorage.getItem("idvaloration"));

    if (this.$route.query.seguimiento === undefined || this.$route.query.seguimiento === null ||  this.$route.query.seguimiento === '' ) {
      this.seguimiento = sessionStorage.getItem("seguimiento");
      console.log('seguimiento 1 --->', this.seguimiento);
    } else {
      this.seguimiento = this.$route.query.seguimiento;
      sessionStorage.setItem("seguimiento", this.seguimiento)
      console.log('seguimiento 2 --->', this.seguimiento);
    }

    //this.tokenCreatio();
    this.tokenComunicaciones();
     window.scrollTo(0,0); 
     this.cargarToken();
     this.tiempoActivo();
     this.getRechazo();
     this.getMotivos();
  },


  onMounted(){
    window.scrollTo(0, 0)
  }
};
</script>

<style>

</style>
